
import { defineComponent } from "vue";
import { mapState } from "vuex";
import NavTop from "@/presentation/components/navigation/NavTop.vue";
import NavSide from "@/presentation/components/navigation/NavSide.vue";
import Record from "@/presentation/components/Record.vue";

function setScrolled() {
  const els_scrolled = document.getElementsByClassName("scrolled");

  for (let el of els_scrolled) {
    el.addEventListener("scroll", () => {
      const el_weeks_days = el.querySelector(".week-row") as Element;
      const el_scrolled = el.querySelector(".week-hours-area") as Element;

      const gb =
        el_weeks_days.getBoundingClientRect().top +
        el_weeks_days.getBoundingClientRect().height;

      if (gb > el_scrolled.getBoundingClientRect().top) {
        el.classList.add("isScrolled");
      } else el.classList.remove("isScrolled");
    });
  }
}

export default defineComponent({
  name: "Main",
  components: {
    NavTop,
    NavSide,
    Record,
  },
  computed: mapState("record", {
    showNewAppointmentModal: "showModal",
  }),
  created(){
    this.$store.dispatch("record/updateActuationsOptions")
  },
  updated: setScrolled,
  mounted: setScrolled,
});
